import React, { useRef } from 'react'
import Content from './index'
import { Layer } from 'components'
import { receiptLayerState } from './states'
import { useRecoilState } from 'recoil'

const ReceiptLayer = () => {
	const [show, setShow] = useRecoilState(receiptLayerState)
	const win = useRef()
	return (
		<Layer show={show} closeLayer={() => setShow(false)} ref={win}>
			<Content pageType="layer" show={show} win={win} />
		</Layer>
	)
}

export default ReceiptLayer